import {
  Droplets,
  Leaf,
  Clock,
  Timer,
  Wind,
  Snowflake,
  Pause,
  CalendarDays,
  RefreshCw,
  AlertTriangle,
  Radio,
  Zap,
  Sunrise,
  type LucideIcon,
} from "lucide-react";
import { C } from "../theme";
import type { FeedKind, Zone, ZoneState, ZoneType, ViewKey } from "../types";

export interface StatusMeta {
  label: string;
  color: string;
  Icon: LucideIcon;
}

export const statusMeta = (s: ZoneState): StatusMeta =>
  ({
    watering: { label: "Watering", color: C.sea, Icon: Droplets },
    idle: { label: "Idle", color: C.textMid, Icon: Clock },
    queued: { label: "Queued", color: C.ice, Icon: Timer },
    "wind-hold": { label: "Wind hold", color: C.beacon, Icon: Wind },
    "freeze-hold": { label: "Freeze hold", color: C.ice, Icon: Snowflake },
    "price-hold": { label: "Price hold", color: C.beacon, Icon: Zap },
    "window-hold": { label: "Off-window", color: C.ice, Icon: Sunrise },
    off: { label: "Off", color: C.textLow, Icon: Pause },
  })[s] ?? { label: s, color: C.textMid, Icon: Clock };

export const feedMeta = (k: FeedKind): { Icon: LucideIcon; c: string } =>
  ({
    run: { Icon: Droplets, c: C.sea },
    skip: { Icon: Wind, c: C.beacon },
    plan: { Icon: CalendarDays, c: C.ice },
    sync: { Icon: RefreshCw, c: C.textLow },
    alert: { Icon: AlertTriangle, c: C.coral },
  })[k] ?? { Icon: Radio, c: C.textMid };

/** Liquid colour: blue while watering, amber below the refill line, sage in-band. */
export const reservoirColor = (z: Zone): string =>
  z.state === "watering" ? C.sea : z.moisture <= z.mad ? C.beacon : C.sage;

export const typeIcon = (t: ZoneType): LucideIcon => (t === "drip" ? Leaf : Droplets);

export const NAV: { key: ViewKey; label: string }[] = [
  { key: "overview", label: "Overview" },
  { key: "zones", label: "Zones" },
  { key: "pump", label: "Pump" },
  { key: "schedule", label: "Schedule" },
  { key: "activity", label: "Activity" },
  { key: "settings", label: "Settings" },
];
